import React, { useEffect, useState } from "react";
import styles from "./escrowView.module.css";
import BasicInfo from "../EscrowViewTabs/BasicInfo/BasicInfo";
import WhitelistingSettings from "../EscrowViewTabs/WhitelistingSettings/WhitelistingSettings";
import FeeConfig from "../EscrowViewTabs/FeeConfig/FeeConfig";
import SubEscrowDetails from "../EscrowViewTabs/SubEscrowDetails/SubEscrowDetails";
import SplitConfig from "../EscrowViewTabs/SplitConfig/SplitConfig";
import { useNavigate, useParams } from "react-router-dom";
import { useAllProduct } from "../../../api-context/commonApiContext";
import config from "../../../service/config";
import FullScreenLoader from "../../../reusable/loader/FullScreenLoader";

const EscrowView = ({ setEscrowView }) => {
  const [activeTab, setActiveTab] = useState("basic");
  const [selectedEscrow, setSelectedEscrow] = useState([]);
  const [subEscrowAllowed, setSubEscrowAllowed] = useState(false);
  const navigate = useNavigate();
  const { clientId, loading, refreshData, setLoading } = useAllProduct();
  const { main_escrow_id } = useParams();
  const tabs = [
    { key: "basic", label: "Basic Info" },
    { key: "whitelist", label: "Whitelisting settings" },
    { key: "fee", label: "Fee config" },
    { key: "subescrow", label: "Sub escrow details" },
    { key: "split", label: "Split Config" },
  ];

  useEffect(() => {
    if (!clientId || !selectedEscrow?.registered_company_name) return;
    setLoading(true);
    fetch(
      `${
        config.node_api_endpoint
      }/api/escrow-subescrow-toggle?client_id=${clientId}&company_name=${encodeURIComponent(
        selectedEscrow.registered_company_name
      )}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          setSubEscrowAllowed(result.isSubEscrowAllowed);
        } else {
          console.error("Failed to fetch toggle value:", result.message);
        }
      })
      .catch((err) => {
        console.error("API error:", err);
      })
      .finally(() => {
        setLoading(false); // ✅ stop loader
      });
  }, [clientId, selectedEscrow, refreshData]);

  useEffect(() => {
    if (main_escrow_id) {
      console.log("Main Escrow ID from URL:", main_escrow_id);
      setLoading(true);
      // fetch data based on main_escrow_id
      fetch(
        `${config.node_api_endpoint}/api/escrow-by-id?client_id=${clientId}&main_escrow_id=${main_escrow_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY, // ✅ your API key here
          },
        }
      )
        .then((res) => res.json())
        .then((data) => {
          setSelectedEscrow(data.data);
          console.log("Escrow Data:", data.data);
        })
        .catch((err) => {
          console.error("Failed to fetch escrow by ID:", err);
        })
        .finally(() => {
          setLoading(false); // ✅ Stop loader
        });
    }
  }, [main_escrow_id]);

  const renderTabContent = () => {
    switch (activeTab) {
      case "basic":
        return <BasicInfo selectedEscrow={selectedEscrow} />;
      case "whitelist":
        return <WhitelistingSettings selectedEscrow={selectedEscrow} />;
      case "fee":
        return <FeeConfig selectedEscrow={selectedEscrow} />;
      case "subescrow":
        return (
          <SubEscrowDetails
            selectedEscrow={selectedEscrow}
            subEscrowAllowed={subEscrowAllowed}
          />
        );
      case "split":
        return <SplitConfig selectedEscrow={selectedEscrow} />;
      default:
        return null;
    }
  };

  return (
    <>
      <FullScreenLoader spinning={loading} />
      <div className="mt-4">
        <button
          className="btn btn-link text-decoration-none ps-0 mb-3"
          style={{ color: "#4C4E64" }}
          onClick={() => navigate("/escrow-management")}
        >
          <span className="me-2">
            <img src="/backArrow.svg" />
          </span>{" "}
          Back
        </button>

        {/* Tab Headers with separators */}
        <ul className={styles.customNavTabs}>
          {tabs.map((tab, i) => (
            <React.Fragment key={tab.key}>
              <li
                className={`${styles.tabItem} ${
                  activeTab === tab.key ? styles.active : ""
                }`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </li>
              {i < tabs.length - 1 && <div className={styles.tabSeparator} />}
            </React.Fragment>
          ))}
        </ul>

        {/* Tab content */}
        <div className="tab-content p-4">{renderTabContent()}</div>
      </div>
    </>
  );
};

export default EscrowView;
